import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState, LoginResult } from "./types";
import { login, refreshAuth } from "./authThunk";
import setAuthToken from "../../utils/setAuthToken";

const initialState: AuthState = {
    token: "",
    isAuthenticated: false,
    user: null,
    error: "",
    loading: false,
    authmessage: "",
    routes: [],
    navigations: []
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = "";
            state.loading = false;
            state.user = null;
        },
        logout: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.token = "";

            setAuthToken({ token: "", refreshToken: "" });
        },
    },
    extraReducers: (builder) => {
        builder.addCase(login.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(
            login.fulfilled,
            (state, action: PayloadAction<LoginResult>) => {
                state.isAuthenticated = action.payload.result;
                state.error = action.payload.error;
                state.token = action.payload.token;
                state.loading = false;
                state.user = action.payload.user;
                state.authmessage = action.payload.message;
                state.navigations = action.payload.navigations ? action.payload.navigations : [];
                state.routes = action.payload.routes ? action.payload.routes : [];
            }
        );
        builder.addCase(login.rejected, (state, action) => {
            state.loading = false;
            state.error =
                action.error.message ||
                "Something went wrong, failed to log in to system";
        });
        builder.addCase(refreshAuth.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(refreshAuth.fulfilled, (state, action) => {

            state.loading = false;
            state.isAuthenticated = true;
            if (!state.user)
                state.user = action.payload.user;
            state.token = action.payload.token;
            state.navigations = action.payload.navigations;
            state.routes = action.payload.routes;
        });
        builder.addCase(refreshAuth.rejected, (state, action) => {
            state.loading = false;
            state.isAuthenticated = false;
            state.error =
                action.error.message ||
                "Something when wrong, failed to refresh authentication";
        });
    },
});

export default authSlice.reducer;
export const { clearError, logout } = authSlice.actions;
